import axios from "axios";

const API = "/api";

const api = axios.create({ baseURL: API, withCredentials: true });

export const fetchUsers = () => api.get("/users").then((r) => r.data);
export const fetchProjects = () => api.get("/projects").then((r) => r.data);
export const createProject = (data) => api.post("/projects", data).then((r) => r.data);
export const deleteProject = (projectId) => api.delete(`/projects/${projectId}`).then((r) => r.data);
export const fetchProject = (key) => api.get(`/projects/${key}`).then((r) => r.data);
export const fetchProjectIssues = (key, boardType, { skip, limit } = {}) =>
  api.get(`/projects/${key}/issues`, { params: { board_type: boardType, skip, limit } }).then((r) => r.data);
export const fetchIssue = (issueKey) => api.get(`/issues/${issueKey}`).then((r) => r.data);
export const createIssue = (data) => api.post("/issues", data).then((r) => r.data);
export const updateIssue = (issueKey, data) => api.patch(`/issues/${issueKey}`, data).then((r) => r.data);
export const deleteIssue = (issueKey) => api.delete(`/issues/${issueKey}`).then((r) => r.data);
export const createInitiative = (data) => api.post("/initiatives", data).then((r) => r.data);
export const uploadAttachment = (file) => {
  const form = new FormData();
  form.append("file", file);
  return api.post("/attachments", form, {
    headers: { "Content-Type": "multipart/form-data" },
  }).then((r) => r.data);
};
export const fetchComments = (issueKey, { skip, limit } = {}) =>
  api.get(`/issues/${issueKey}/comments`, { params: { skip, limit } }).then((r) => r.data);
export const createComment = (issueKey, data) => api.post(`/issues/${issueKey}/comments`, data).then((r) => r.data);
export const updateComment = (commentId, data) => api.patch(`/comments/${commentId}`, data).then((r) => r.data);
export const deleteComment = (commentId) => api.delete(`/comments/${commentId}`).then((r) => r.data);
export const searchIssues = (q) => api.get("/search", { params: { q } }).then((r) => r.data);
export const fetchDashboard = () => api.get("/dashboard").then((r) => r.data);
export const fetchCrossProjectIssues = (params) =>
  api.get("/cross-project/issues", { params }).then((r) => r.data);

// Admin users
export const adminInviteUser = (data) => api.post("/admin/users", data).then((r) => r.data);
export const adminUpdateUser = (userId, data) =>
  api.patch(`/admin/users/${userId}`, data).then((r) => r.data);

// Slack settings
export const fetchSlackSettings = () => api.get("/admin/slack-settings").then((r) => r.data);
export const updateSlackSettings = (data) => api.put("/admin/slack-settings", data).then((r) => r.data);
export const testSlackWebhook = (botToken, webhookUrl, channel) => api.post("/admin/slack-test", { bot_token: botToken, webhook_url: webhookUrl, channel }).then((r) => r.data);
export const triggerDueDateCheck = () => api.post("/admin/due-date-check").then((r) => r.data);

// Auth
export const authLogin = (email, password) => api.post("/auth/login", { email, password }).then((r) => r.data);
export const authRegister = (data) => api.post("/auth/register", data).then((r) => r.data);
export const authLogout = () => api.post("/auth/logout").then((r) => r.data);
export const authMe = () => api.get("/auth/me").then((r) => r.data);

export default api;
